import { constants } from '@wix/motion-edm-autogen-common';
import { transformations } from '../common';
var ARRAY_ITEMS_PATH_PROPERTY_NAME = transformations.ARRAY_ITEMS_PATH_PROPERTY_NAME, ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME = transformations.ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME;
var DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME = constants.DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME;
var ITEMS_RESULT_PROPERTY_NAME = 'items';
var PAGING_METADATA_RESULT_PROPERTY_NAME = 'pagingMetadata';
var buildRequestTransformation = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.requestQueryObjectPropertyName, requestQueryObjectPropertyName = _d === void 0 ? DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME : _d;
    return (_b = {},
        _b[requestQueryObjectPropertyName] = '$[0]',
        _b['*'] = '$[1]',
        _b);
};
var buildResponseTransformation = function (_a) {
    var _b, _c;
    var responseMessageResultPath = _a.responseMessageResultPath, responseMessagePagingMetadataPath = _a.responseMessagePagingMetadataPath, itemTransformation = _a.itemTransformation;
    return (_b = {},
        _b[ITEMS_RESULT_PROPERTY_NAME] = itemTransformation
            ? (_c = {},
                _c[ARRAY_ITEMS_PATH_PROPERTY_NAME] = "$.".concat(responseMessageResultPath),
                _c[ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME] = itemTransformation,
                _c) : "$.".concat(responseMessageResultPath),
        _b[PAGING_METADATA_RESULT_PROPERTY_NAME] = "$.".concat(responseMessagePagingMetadataPath),
        _b);
};
export { buildRequestTransformation, buildResponseTransformation, ITEMS_RESULT_PROPERTY_NAME, PAGING_METADATA_RESULT_PROPERTY_NAME, };
//# sourceMappingURL=query.js.map